import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App.tsx";
import "./index.css";
import { RealtimeProvider } from "./context/RealtimeContext"; // <-- import here

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <RealtimeProvider>
            <App />
        </RealtimeProvider>
    </StrictMode>
);
